<template>
    <modal :title="$t(title)" :visible.sync="isShowDialog" append-to-body :top="'8vh'" width="940px">
        <!-- 查询区 -->
        <div class="content">
            <el-tabs v-model="activeActiveCom" type="card" @tab-click="handleTabs">
                <el-tab-pane v-for="item in tabs" :key="item.key" :name="item.name" :label="$t(item.label)"> </el-tab-pane>
            </el-tabs>
            <component v-bind="$attrs" :is="activeActiveCom" @updateClose="updateClose"></component>
            <!-- <searchRegin v-bind="$attrs" @handleShowFn="handleShowFn" /> -->
            <!-- 处理区 -->
            <!--  v-show="isDetailShow" -->
            <!-- <handleRegion v-bind="$attrs" :handleData="handleData" ref="handleRegion" /> -->
            <!-- 选择区 -->
            <!-- <chaoozeRegion ref="chaoozeRegion" v-bind="$attrs" /> -->
        </div>
        <div slot="footer">
            <el-button type="primary" @click="() => (isShowDialog = false)">{{ $t('integration.cancel') }}</el-button>
        </div>
    </modal>
</template>

<script>
// import searchRegin from './children/searchRegion.vue';
// import handleRegion from './children/handleRegion.vue';
// import chaoozeRegion from './children/chaoozeRegion.vue';
import handle from './children/component/handleCom.vue';
import record from './children/component/recordCom';
export default {
    props: ['title', 'isShow'],
    components: {
        // searchRegin,
        // handleRegion,
        // chaoozeRegion
        handle,
        record
    },
    watch: {
        // isShow() {
        //     this.isDetailShow = false;
        // }
    },
    computed: {
        isShowDialog: {
            get: function() {
                return this.isShow;
            },
            set: function(val) {
                this.$emit('update:isShow', val); //可以优化成model  或者minx
            }
        }
    },

    data() {
        return {
            activeActiveCom: 'handle',
            tabs: [
                {
                    id: 1,
                    name: 'handle',
                    label: $t('integration.handle')
                },
                {
                    id: 2,
                    name: 'record',
                    label: $t('integration.record')
                }
            ],
            isDetailShow: false,
            isDetailShow2: false,
            handleData: {}
        };
    },
    mounted() {},
    methods: {
        // handleShowFn(bool) {
        //     this.isDetailShow2 = bool;
        // },
        handleTabs() {},
        updateClose(info) {
            this.isShowDialog = false;
            this.$emit('updateRow', info);
        }
    }
};
</script>

<style lang="scss" scoped>
.content {
    height: 740px;
    overflow: auto;
    overflow-x: hidden;
}
</style>
